import { useTranslation } from "react-i18next";
import { PlusCircle } from "lucide-react";
import { useSplitScreenContext } from "./split-screen-context";
import { Button } from "@/components/ui/button";
import { SplitModulePicker } from "./split-module-picker";

export const SplitPanelEmptyState = ({
  moduleNotFound,
}: {
  moduleNotFound?: boolean;
}) => {
  const { t } = useTranslation(["common"]);
  const { isModulePickerOpen, toggleModulePicker, stopSplitScreen } =
    useSplitScreenContext();

  const icon = (
    <div className="bg-violet-200 text-primary p-2 rounded-full">
      <PlusCircle size={36} />
    </div>
  );

  const labels: { title: string; subtitle: string } = {
    title: moduleNotFound
      ? t("common:chrome.module_not_available_or_not_supported")
      : t("common:chrome.select_a_module_to_display"),
    subtitle: moduleNotFound
      ? t(
          "common:chrome.the_selected_module_is_not_available_at_the_moment_or_no",
        )
      : t("common:chrome.choose_a_module_to_display_here"),
  };

  return (
    <>
      <div className="h-full flex flex-col gap-3 items-center justify-center">
        {icon}
        <div className="text-center">
          <h2 className="text-lg font-semibold text-black">{labels.title}</h2>
          <p className="text-sm text-black/50">{labels.subtitle}</p>
        </div>
        <Button onClick={toggleModulePicker} className="text-sm! w-44">
          {t("common:chrome.browse_modules")}
        </Button>
        <Button
          onClick={stopSplitScreen}
          className="text-sm! w-44"
          variant="outline"
        >
          {t("common:buttons.cancel")}
        </Button>
      </div>
      <SplitModulePicker
        isOpen={isModulePickerOpen}
        toggle={toggleModulePicker}
      />
    </>
  );
};
